<!-- 
出荷ラベルカード
@props
  destinationLabel 出荷ラベルの入力内容
-->

<template>
  <div>
    <v-row align="center">
      <v-col cols="10">
        <!-- カード -->
        <v-card
          elevation="3"
          :class="{
            'card-warning': cardColor == 20,
            'card-error': cardColor == 30,
          }"
        >
          <v-card-text>
            <v-row>
              <v-card-title class="custom-card-title">名称</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="auto">
                    <v-radio-group
                      row
                      v-model="destinationLabel.name"
                      class="big-radio-group"
                      @change="sendDestinationLabel"
                    >
                      <v-radio
                        label="生食用"
                        color="#0ddbc7"
                        :value="1"
                      ></v-radio>
                      <v-radio
                        label="加熱用"
                        color="#0ddbc7"
                        :value="2"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-row>
            <v-row>
              <v-card-title class="custom-card-title">消費期限</v-card-title>
              <v-menu flat v-model="showDatePicker" z-index="0" :close-on-click="false" :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <v-textarea
                    style="padding-left: 12px; padding-right: 12px"
                    color="#0ddbc7"
                    v-model="displayDate"
                    v-bind="attrs"
                    v-on="on"
                    readonly
                    outlined
                    hide-details="auto"
                    class="text-h5"
                    rows="1"
                    auto-grow
                  ></v-textarea>
                </template>
                <v-date-picker
                  locale="jp"
                  v-model="selectDate"
                  elevation="12"
                  :width="400"
                  :day-format="pickupDate"
                  :picker-date="pickerDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="datePickerCancel">キャンセル</v-btn>
                  <v-btn text color="primary" @click="updateDate">OK</v-btn>            
                </v-date-picker>
              </v-menu>
            </v-row>
            <v-row>
              <v-card-title class="custom-card-title">保存方法</v-card-title>
              <v-text-field
                style="padding-left: 12px; padding-right: 12px"
                color="#0ddbc7"
                v-model="$v.formData.temperature.$model"
                regular
                class="text-h6 text-align:center"
                @change="sendDestinationLabel"
                :error-messages="temperatureErrorMessage"
              ></v-text-field>
              <p
                style="text-align: right; top: 5px; position: relative"
                class="custom-card-text"
              >
                ℃
              </p>
            </v-row>
            <p
              style="text-align: right; top: 5px; position: relative"
              class="custom-card-text"
            >
              以下で保存して下さい
            </p>
            <v-row>
              <v-card-title class="custom-card-title">採取海域</v-card-title>
              <p
                style="text-align: left; top: 16px; position: relative"
                class="custom-card-text"
              >
                {{ seaAreaItem[seaAreaItemIndex] }}
              </p>
            </v-row>
            <v-row>
              <v-card-title class="custom-card-title">加工者</v-card-title>
              <v-textarea
                style="padding-left: 12px; padding-right: 12px"
                color="#0ddbc7"
                ref="destinationLabel.processingPerson"
                v-model="destinationLabel.processingPerson"
                class="text-h6 text-align:center"
                auto-grow
                rows="1"
                @change="sendDestinationLabel"
              ></v-textarea>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="1">
        <v-btn
          slot="append"
          icon
          outlined
          color="primary"
          @click="removeConfirm()"
        >
          <v-icon>mdi-minus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- カード削除確認ダイアログ -->
    <confirm-dialog ref="confirm_remove_card" @on-click-ok="remove()">
      削除しますか？
    </confirm-dialog>
  </div>
</template>

<script>
import Validate from "@/logic/common/validate.js";
import ConfirmDialog from "../dialog/confirmWkReg.vue";
import DateWrapper from "../../logic/common/date-wrapper";

const CARD_COLOR_NOMAL = 10;
const CARD_COLOR_WARNING = 20;
const CARD_COLOR_ERROR = 30;

export default {
  name: "destination-label-card",
  components: {
    "confirm-dialog": ConfirmDialog,
  },
  props: {
    destinationLabel: {
      name: "",
      expirationDate: "",
      temperature: "",
      seaArea: "", // shipping-editで指定した海域を表示
      processingPerson: "",
      index: "",
    },
  },
  /**
   * 出入力の検証
   */
  validations: {
    formData: {
      // 保存方法 温度
      temperature: {
        signedDecimalNumber: Validate.rule.signedDecimalNumber,
      },
    },
  },
  watch: {},
  computed: {
    /**
     * formDataの入力が不正ならtrueを返す
     */
    hasErrorFormData() {
      return Validate.hasError([this.$v.formData.temperature]);
    },
    /**
     * エラーメッセージ：保存方法 温度
     */
    temperatureErrorMessage() {
      return Validate.buildLocalizedErrorMessage(
        this.$v.formData.temperature,
        "温度",
        ["signedDecimalNumber"]
      );
    },
    cardColor: function () {
      if (
        this.destinationLabel.name === "" ||
        this.destinationLabel.expirationDate === "" ||
        this.formData.temperature === "" ||
        this.destinationLabel.processingPerson === "" ||
        this.hasErrorFormData
      ) {
        if (this.index === 0) {
          return CARD_COLOR_ERROR;
        } else {
          return CARD_COLOR_WARNING;
        }
      } else {
        return CARD_COLOR_NOMAL;
      }
    },
    /**
     * 選択日を表示日時に変換して返す
     */
    displayDate: function () {
      if (this.selectDate === "") {
        return "";
      } else {
        return new DateWrapper(this.selectDate).format.localizedDate;
      }
    },
    /**
     * 採取海域の数値をseaAreaItemのインデックスにして返す
     */
    seaAreaItemIndex() {
      if (this.destinationLabel.seaArea === "") {
        return -1;
      }
      let i = this.destinationLabel.seaArea - 1;
      return i;
    },
  },
  data() {
    this.seaAreaItem = [
      "広島湾西部",
      "広島湾北部",
      "広島湾中部",
      "広島湾南部",
      "呉湾",
      "広湾",
      "三津湾",
      "広島県東部",
    ];
    let inputDate = "";
    if (this.destinationLabel.expirationDate) {
      inputDate = new DateWrapper(this.destinationLabel.expirationDate).format
        .systemDate;
    }
    return {
      showDatePicker: false,
      index: this.destinationLabel.index,
      selectDate: inputDate,
      beforeFocus: inputDate,
      pickerDate: null,
      formData: {
        temperature: this.destinationLabel.temperature,
      },
    };
  },
  methods: {
    /**
     * カードの削除前確認
     */
    removeConfirm() {
      if (
        this.destinationLabel.name === "" &&
        this.destinationLabel.expirationDate === "" &&
        this.destinationLabel.temperature === "" &&
        this.destinationLabel.processingPerson === ""
      ) {
        // カードが未入力の場合、確認ダイアログを表示せず削除する
        this.remove();
        return;
      }
      this.$refs.confirm_remove_card.showDialog();
    },
    /**
     * カードを削除する
     */
    remove() {
      this.$emit("on-click-remove");
    },
    /**
     * カード削除後、propsの値を参照し直す
     */
    reload() {
      let inputDate = "";
      if (this.destinationLabel.expirationDate) {
        inputDate = new DateWrapper(this.destinationLabel.expirationDate).format
          .systemDate;
      }
      this.selectDate = inputDate;
      this.formData.temperature = this.destinationLabel.temperature;
      this.index = this.destinationLabel.index;
      // カード色の変更を親に通知する
      this.sendDestinationLabel();
    },
    /**
     * 入力された値を親に通知する
     */
    sendDestinationLabel() {
      let args = {
        name: this.destinationLabel.name,
        expirationDate: this.destinationLabel.expirationDate,
        temperature: this.formData.temperature,
        seaArea: this.destinationLabel.seaArea,
        processingPerson: this.destinationLabel.processingPerson,
        cardColor: this.cardColor,
        hasErrorFormData: this.hasErrorFormData,
      };
      this.$emit("change-destination-label", args);
    },
    /**
     * カレンダー：対象日から日を取得する
     */
    pickupDate(date_string) {
      return new DateWrapper(date_string).format.build((d) => `${d.date.d}`);
    },
    /**
     * カレンダー：日付をAPI指定用形式に変換する
     */
    updateDate() {
      this.destinationLabel.expirationDate = this.selectDate.replace(/-/g, "/");
      this.beforeFocus = this.selectDate;
      this.sendDestinationLabel();
      // カレンダーピッカーを閉じる
      this.showDatePicker = false;
    },
    /**
     * カレンダー：カレンダーピッカーの選択をキャンセルして閉じる
     */
    datePickerCancel() {
      // カレンダーピッカーのカーソルを変更前に戻す
      this.selectDate = this.beforeFocus;
      // カレンダーピッカーを開いた時の表示月を変更前に戻す
      this.pickerDate = this.beforeFocus;
      // カレンダーピッカーを閉じる
      this.showDatePicker = false;
    },
  },
};
</script>

<style scoped>
.card-warning {
  background-color: #fff8dc;
  max-width: 750px;
  padding-right: 10px;
}
.card-error {
  background-color: #ffdbe2;
  max-width: 750px;
  padding-right: 10px;
}
.custom-card-title {
  font-size: 24px;
  color: #333;
  line-height: 1.5;
  margin: 0px;
}
.custom-card-subtitle {
  font-size: 16px;
  margin: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
}
.custom-card-text {
  font-size: 24px;
  line-height: 1.3;
}
.big-radio-group {
  transform: scale(1.4);
  font-size: 24px;
  margin-left: 32px;
  margin-right: 32px;
}
</style>
